// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3EBkT","title":"Header_title__1DQkj","side":"Header_side__2xjiW"};